module.exports = "https://dashboard.cdn.gifty.nl/6189/images/emoti-3.png?fd63d2b586fd4621b60f17bcfd317282";